import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_NEWLY_CREATED_PETITIONS = defineFcm('petition_page_newly_created_petitions')
	.asBoolean()
	.withDefault(false)
	.toConfig();
